module.exports = __webpack_public_path__ + "img/img_4.c33e3033.png";